import { SiteIssueType } from "../../../../enums/SiteIssueType";

export const SITE_ISSUE_TYPES = [
    SiteIssueType.BiometricDeviceUnavailable,
    SiteIssueType.DmpPanelUnavailable,
    SiteIssueType.HmiUnavailable,
    SiteIssueType.InconsistentBox,
    SiteIssueType.SensorMissing,
    SiteIssueType.SensorTamper,
    SiteIssueType.SensorBatteryLow,
    SiteIssueType.DoorLeftOpen,
    SiteIssueType.BoxLeftOpen,
    SiteIssueType.SiteDataQualityIssue,
];

export const SITE_ISSUE_TYPE_LABELS: { [key in SiteIssueType]: string; } = {
    [SiteIssueType.BiometricDeviceUnavailable]: "Biometric Device Unavailable",
    [SiteIssueType.DmpPanelUnavailable]: "Panel Unavailable",
    [SiteIssueType.HmiUnavailable]: "HMI Unavailable",
    [SiteIssueType.InconsistentBox]: "Box In Inconsistent State",
    [SiteIssueType.SensorMissing]: "Sensor Missing",
    [SiteIssueType.SensorTamper]: "Sensor Tampered",
    [SiteIssueType.SensorBatteryLow]: "Sensor Battery Low",
    [SiteIssueType.DoorLeftOpen]: "Door Left Open",
    [SiteIssueType.BoxLeftOpen]: "Box Left Open",
    [SiteIssueType.SiteDataQualityIssue]: "Site Data Quality Issue",
};
